import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'

export const useLoadAuth = () => {
  const http = useHttp()

  return useQuery({
    queryKey: ['auth'],
    queryFn: () => http.get('/user/'),
    retry: false,
  })
}
